import type { PropsWithChildren } from 'react';
import React from 'react';

import { useRadioGroup } from '@react-aria/radio';
import type { AriaRadioGroupProps } from '@react-aria/radio';
import { mergeProps } from '@react-aria/utils';

import { useRadioGroupState } from '@react-stately/radio';
import type { RadioGroupState } from '@react-stately/radio';

export const ClickRadioContext = React.createContext<RadioGroupState | null>(null);

export interface IRadioGroupProps {
  className?: string;
}

export interface ILabelProps {}

export interface IProps extends AriaRadioGroupProps, PropsWithChildren {
  labelProps?: ILabelProps;
  radioGroupProps?: IRadioGroupProps;
}

const ClickRadioGroup: React.FC<IProps> = (props) => {
  const { children, label } = props;

  const state = useRadioGroupState(props);

  const { radioGroupProps, labelProps } = useRadioGroup(props, state);

  return (
    <div>
      {label && (
        <div className={'click-label'} {...mergeProps(labelProps, props.labelProps ?? {})}>
          {label} {props.isRequired && <span className="text-normal pl-px text-rose-600">*</span>}
        </div>
      )}
      <ClickRadioContext.Provider value={state}>
        <div {...mergeProps(radioGroupProps, props.radioGroupProps ?? {})}>{children}</div>
      </ClickRadioContext.Provider>
    </div>
  );
};

export default ClickRadioGroup;
